import { render, staticRenderFns } from "./PaymentConfirmationPage.vue?vue&type=template&id=2695f146&"
import script from "./PaymentConfirmationPage.vue?vue&type=script&lang=js&"
export * from "./PaymentConfirmationPage.vue?vue&type=script&lang=js&"
import style0 from "./PaymentConfirmationPage.vue?vue&type=style&index=0&id=2695f146&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports